import React from 'react';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import {
  WatcherLight,
  WatcherEnterpriseSearchQueryParams,
  WatcherLawFirmSearchQueryParams,
  WatcherLawyerSearchQueryParams,
  NewWatcherEntityQueryParams,
  NewWatcherEnterpriseQueryParams,
  NewWatcherLawyerQueryParams,
  NewWatcherLawFirmQueryParams,
  WatcherLightWithoutDecisionCount,
} from './watchers.types';
import { ReactComponent as LawFirmIcon } from '../../../public/img/icons/entities/law-firm.svg';
import { ReactComponent as LawyerIcon } from '../../../public/img/icons/entities/lawyer.svg';
import { ReactComponent as EnterpriseIcon } from '../../../public/img/icons/entities/enterprise.svg';
import { ReactComponent as QueryIcon } from '../../../public/img/icons/keywords.svg';
import { BrokenImageLinkTest } from '../components/BrokenImageLinkTest';
import styles from './watchers_utils.module.scss';

export const fakeWaitingTime: number = 3000;

function getPartyCategory(selectorParty?: {
  name?: string;
  type?: string;
}): string {
  if (!selectorParty) return '';

  let partyCategory;

  if (selectorParty.name) {
    partyCategory = selectorParty.name;
  } else if (selectorParty.type === 'PP') {
    partyCategory = 'Personne physique';
  } else {
    partyCategory = 'Personne morale';
  }

  return partyCategory;
}

export function getParties(searchQuery: {
  party?: { name?: string; type?: string } | null;
  otherParty?: { name?: string; type?: string } | null;
}): string {
  const party = searchQuery.party ? getPartyCategory(searchQuery.party) : '';
  const otherParty = searchQuery.otherParty
    ? getPartyCategory(searchQuery.otherParty)
    : '';

  if (party && otherParty) {
    return `Parties : ${party} contre ${otherParty}`;
  }
  if (party) {
    return `Parties : ${party}`;
  }
  if (otherParty) {
    return `Parties : ${otherParty}`;
  }

  return '';
}

export function handleWatchersPageError(
  handleError: Function,
  error: { response: { status: number } },
) {
  const { response } = error;
  if (response && (response.status === 400 || response.status === 404)) {
    handleError();
  }
}

export function sendWatcherCreatedEvent(data: {
  key: string;
  source: string;
  reportOriginalQueryKey?: boolean;
}) {
  doctrineAnalytics('SearchWatch WatcherCreated', data);
}

export function sendWatcherDeletedEvent(data: {
  key?: string;
  source: string;
}) {
  doctrineAnalytics('SearchWatch WatcherDeleted', data);
}

export function getWatcherTitle(
  watcher: WatcherLight | WatcherLightWithoutDecisionCount,
): string {
  const keywords =
    watcher.searchQuery.selectedKeywords &&
    watcher.searchQuery.selectedKeywords.length
      ? watcher.searchQuery.selectedKeywords.reduce(
          (keywordsTitle, keyword) => `${keywordsTitle} · ${keyword}`,
          '',
        )
      : '';
  return `${watcher.searchQuery.query}${keywords}`;
}

export function getWatcherTypeIcon(watcher: WatcherLight) {
  if ((watcher.searchQuery as WatcherEnterpriseSearchQueryParams).eid) {
    return <EnterpriseIcon />;
  }

  if ((watcher.searchQuery as WatcherLawFirmSearchQueryParams).oid) {
    return <LawFirmIcon />;
  }

  if ((watcher.searchQuery as WatcherLawyerSearchQueryParams).lid) {
    const pictureUrl =
      (watcher.searchQuery as WatcherLawyerSearchQueryParams).pictureUrl || '';
    return (
      <BrokenImageLinkTest url={pictureUrl}>
        {(isImageLinkBroken: boolean) =>
          pictureUrl && !isImageLinkBroken ? (
            <img
              className={styles.lawyerPicture}
              src={pictureUrl}
              alt="lawyer-profile"
            />
          ) : (
            <LawyerIcon />
          )
        }
      </BrokenImageLinkTest>
    );
  }

  return <QueryIcon />;
}

export function getWatcherEntityLabel(
  queryParams: NewWatcherEntityQueryParams,
) {
  if ((queryParams as NewWatcherEnterpriseQueryParams).eid) {
    return 'cette entreprise';
  }

  if ((queryParams as NewWatcherLawFirmQueryParams).oid) {
    return 'ce cabinet';
  }

  if ((queryParams as NewWatcherLawyerQueryParams).lid) {
    return 'cet avocat';
  }

  return '';
}
